
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ocean-smart-meter-backup-switch",
      function () {
        return require("private-next-pages/ocean-smart-meter-backup-switch/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ocean-smart-meter-backup-switch"])
      });
    }
  